<form [formGroup]="employmentDataForm" class="k-form">
  <div class="two-column-layout k-d-grid">
    <div class="col">
      <kendo-formfield orientation="horizontal">
        <kendo-label
          class="!k-align-items-start"
          [for]="employedSince"
          text="Anstellung ab"
        ></kendo-label>
        <kendo-datepicker
          [id]="formControlNames.EmployedSince"
          [formControlName]="formControlNames.EmployedSince"
          #employedSince
        >
        </kendo-datepicker>
        <kendo-formerror>Error: Username is required</kendo-formerror>
      </kendo-formfield>
    </div>
  </div>

  <div class="two-column-layout k-d-grid">
    <div class="col">
      <button
        kendoButton
        rounded="full"
        size="large"
        themeColor="secondary"
        (click)="openWorkingTimeDialog()"
      >
        Arbeitszeiten bearbeiten
      </button>

      <button
        kendoButton
        rounded="full"
        size="large"
        themeColor="secondary"
        (click)="openAnnualVacationQuotaDialog()"
      >
        Urlaubstage bearbeiten
      </button>
    </div>
  </div>
</form>
